import BaseGauge from 'canvas-gauges';

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
import { GridStack } from 'gridstack';

try {
    //require('./Utils');
    //require('./LoaderHelper');
    window.GridStack = require('gridstack/dist/es5/gridstack-all');

    window.$ = window.jQuery = require('jquery');
    require('jquery-ui-dist/jquery-ui.min');
    require('select2');
    window.Popper = require('popper.js').default;
    //require('bootstrap/dist/js/bootstrap');
    window.Picker = require('vanilla-picker/dist/vanilla-picker.min');
    //window.colorpicker = require('bootstrap-colorpicker/dist/js/bootstrap-colorpicker');

    require('@coreui/coreui-pro');
    require('@coreui/utils/dist/coreui-utils');
    require('@splidejs/splide/dist/js/splide.min');
    //window.Noty = require('noty');

    window.flatted = require('flatted');
    //require('jquery-ui-dist/jquery-ui.min');
    window.ClipboardJS = require('clipboard');
    window.AOS = require('aos');
    window.MobileDetect = require('mobile-detect');
    window.numeral = require('numeral');
    window.Lazy = require('jquery-lazy');
    window.$.debounce = require('debounce');
    window.moment = require('moment');
    require('moment-timezone');

    require('leaflet');
    require('leaflet.markercluster');
    require('leaflet.locatecontrol');
    require('leaflet-search/dist/leaflet-search.min.css');
    //require('leaflet-control-geocoder');
    window.GeoSearch = require('leaflet-geosearch');
    require('jquery-mousewheel');
    require('jquery.event.drag');
    //require('flot/dist/es5/jquery.flot');
    //require('./vendor/jquery.flot.crosshair');
    //require('./vendor/jquery.flot.navigate');
    //require('./vendor/curvedLines');
    window.jp = require('jsonpath');

    require('hammerjs');
    require('rangeslider.js');
    require('dropzone');
    require('owl.carousel');
    window.Quill = require('quill');
    window.introJs = require('intro.js');

    //window.Muuri = require('muuri/dist/muuri.min');
    //window.Hammer = require('hammerjs');

    require('tablesorter');
    require('jquery-confirm');
    require('jquery-serializejson');
    require('jquery-match-height');
    require('jquery.simple-scroll-follow');
    require('perfect-scrollbar');

    require('datatables.net');
    require('datatables.net-responsive/js/dataTables.responsive');
    require('datatables.net-responsive-bs4/js/responsive.bootstrap4');
    require('datatables.net-keytable');
    require('datatables.net-select');
    require('datatables.net-colreorder');
    require('dt-colresize');
    //require('datatables.net-buttons/js/dataTables.buttons');
    //require('datatables.net-buttons-bs4/js/buttons.bootstrap4');
    //require('datatables.net-buttons/js/buttons.print.js');
    //require('datatables.net-buttons/js/buttons.colVis.js');
    //require('datatables.net-buttons/js/buttons.html5.js');
    //require('datatables.net-buttons/js/buttons.flash.js');
    window.datetimepicker = require('tempusdominus-bootstrap-4');
    window.MCDatepicker = require('mc-datepicker');
    window.flatpicker = require('flatpickr');
    require('flatpickr/dist/l10n/de.js');
    require('flatpickr/dist/l10n/es.js');
    require('cleave.js');
    require('video.js');
    require('chartjs-adapter-moment');
    require('vanilla-lazyload');
    require('lazysizes/lazysizes');
    require('lazysizes/plugins/blur-up/ls.blur-up.min');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
